var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHcpiNewEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#e04444;}.cls-3{fill:#ffe1d4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.12,
    y: 1.11,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.12,
    y: 1.11,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hcpi_new_entry"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 299.84,
    cy: 299.92,
    r: 299.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M447.7,244.64h-90V159.73a56,56,0,0,0-55.85-55.85h0A56,56,0,0,0,246,159.73v84.91H166.09a56,56,0,0,0-55.85,55.85h0a56,56,0,0,0,55.85,55.85H246v85a56,56,0,0,0,55.85,55.85h0a56,56,0,0,0,55.85-55.85v-85h90a56,56,0,0,0,55.85-55.85h0A56,56,0,0,0,447.7,244.64Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHcpiNewEntry);
export default __webpack_public_path__ + "static/media/hcpi_new_entry.257019efde2553ba801c610f16854866.svg";
export { ForwardRef as ReactComponent };